/* i18n translations for community platform */
const T = {
  ko: {
    community: "리뷰 라운지",
    communityDesc: "복합기·프린터 리뷰와 이야기를 나눠보세요",
    review: "리뷰",
    writeAsReview: "리뷰로 작성",
    reviewSummary: "리뷰 요약",
    all: "전체",
    latest: "최신",
    hot: "인기",
    top: "추천순",
    write: "글쓰기",
    writeNew: "새 게시글 작성",
    cancel: "취소",
    submit: "게시하기",
    submitting: "게시 중...",
    title: "제목을 입력하세요",
    content: "내용을 입력하세요",
    setNickname: "닉네임 설정",
    nickDesc: "커뮤니티 활동을 위해 닉네임을 설정해주세요",
    nickPlaceholder: "2~20자 (한글, 영문, 숫자, _)",
    confirm: "설정",
    backToList: "목록으로",
    upvote: "추천",
    comments: "댓글",
    reply: "답글",
    delete: "삭제",
    edit: "수정",
    editDone: "수정 완료",
    pinned: "고정",
    blinded: "블라인드 처리된 게시글입니다",
    noPostsYet: "아직 게시글이 없습니다",
    beFirst: "첫 번째 게시글을 작성해보세요!",
    commentPlaceholder: "댓글을 입력하세요",
    loginRequired: "로그인 후 댓글 작성이 가능합니다",
    register: "등록",
    replyingTo: "답글 작성 중",
    views: "조회",
    blindedComment: "블라인드 처리된 댓글입니다",
    tonerPoints: "토너 포인트",
    badge: "뱃지",
    selectAll: "모두 입력해주세요",
    globalInquiry: "해외 문의",
    globalInquiryDesc: "해외에서 복합기 관련 문의를 보내주세요",
    name: "이름",
    email: "이메일",
    country: "국가",
    subject: "제목",
    message: "메시지",
    send: "보내기",
    inquirySuccess: "문의가 접수되었습니다. 이메일로 답변 드리겠습니다.",
    language: "언어",
    selectCategory: "카테고리를 선택하세요",
    postLang: "글 작성 언어",
    serviceCta: "A/S 신청",
    serviceCtaDesc: "전문 엔지니어 방문",
    rentalCta: "렌탈 문의",
    rentalCtaDesc: "최적의 렌탈 상담",
    deleteConfirm: "삭제하시겠습니까?",
    deleted: "삭제되었습니다",
  },
  en: {
    community: "Review Lounge",
    communityDesc: "Share reviews and stories about copiers & printers",
    review: "Review",
    writeAsReview: "Write as review",
    reviewSummary: "Review Summary",
    all: "All",
    latest: "Latest",
    hot: "Hot",
    top: "Top",
    write: "Write",
    writeNew: "New Post",
    cancel: "Cancel",
    submit: "Post",
    submitting: "Posting...",
    title: "Enter title",
    content: "Enter content",
    setNickname: "Set Nickname",
    nickDesc: "Set a nickname for community activity",
    nickPlaceholder: "2-20 chars (letters, numbers, _)",
    confirm: "Confirm",
    backToList: "Back to List",
    upvote: "Upvote",
    comments: "Comments",
    reply: "Reply",
    delete: "Delete",
    edit: "Edit",
    editDone: "Save",
    pinned: "Pinned",
    blinded: "This post has been hidden by moderator",
    noPostsYet: "No posts yet",
    beFirst: "Be the first to write!",
    commentPlaceholder: "Write a comment",
    loginRequired: "Login to comment",
    register: "Post",
    replyingTo: "Replying",
    views: "Views",
    blindedComment: "Hidden by moderator",
    tonerPoints: "Toner Points",
    badge: "Badge",
    selectAll: "Please fill in all fields",
    globalInquiry: "Global Inquiry",
    globalInquiryDesc: "Send us an inquiry about copiers from overseas",
    name: "Name",
    email: "Email",
    country: "Country",
    subject: "Subject",
    message: "Message",
    send: "Send",
    inquirySuccess: "Your inquiry has been submitted. We will reply via email.",
    language: "Language",
    selectCategory: "Select category",
    postLang: "Post language",
    serviceCta: "Request A/S",
    serviceCtaDesc: "Professional engineer visit",
    rentalCta: "Rental Inquiry",
    rentalCtaDesc: "Best rental consultation",
    deleteConfirm: "Are you sure you want to delete?",
    deleted: "Deleted",
  },
  ja: {
    community: "レビューラウンジ",
    communityDesc: "複合機・プリンターのレビューと情報を共有しましょう",
    review: "レビュー",
    writeAsReview: "レビューとして投稿",
    reviewSummary: "レビューまとめ",
    all: "すべて",
    latest: "最新",
    hot: "人気",
    top: "おすすめ",
    write: "投稿",
    writeNew: "新規投稿",
    cancel: "キャンセル",
    submit: "投稿する",
    submitting: "投稿中...",
    title: "タイトルを入力",
    content: "内容を入力",
    setNickname: "ニックネーム設定",
    nickDesc: "コミュニティ活動のためにニックネームを設定してください",
    nickPlaceholder: "2~20文字",
    confirm: "設定",
    backToList: "一覧へ",
    upvote: "推薦",
    comments: "コメント",
    reply: "返信",
    delete: "削除",
    edit: "編集",
    editDone: "保存",
    pinned: "固定",
    blinded: "管理者により非表示",
    noPostsYet: "まだ投稿がありません",
    beFirst: "最初の投稿を書いてみましょう！",
    commentPlaceholder: "コメントを入力",
    loginRequired: "ログイン後にコメント可能",
    register: "登録",
    replyingTo: "返信中",
    views: "閲覧",
    blindedComment: "管理者により非表示",
    tonerPoints: "トナーポイント",
    badge: "バッジ",
    selectAll: "すべて入力してください",
    globalInquiry: "海外お問い合わせ",
    globalInquiryDesc: "海外からの複合機に関するお問い合わせ",
    name: "名前",
    email: "メール",
    country: "国",
    subject: "件名",
    message: "メッセージ",
    send: "送信",
    inquirySuccess: "お問い合わせが送信されました。メールで返信いたします。",
    language: "言語",
    selectCategory: "カテゴリを選択",
    postLang: "投稿言語",
    serviceCta: "A/S申請",
    serviceCtaDesc: "専門エンジニア訪問",
    rentalCta: "レンタルお問い合わせ",
    rentalCtaDesc: "最適なレンタル相談",
    deleteConfirm: "削除しますか？",
    deleted: "削除しました",
  },
  ru: {
    community: "Зал обзоров",
    communityDesc: "Делитесь отзывами и историями о копирах и принтерах",
    review: "Обзор",
    writeAsReview: "Написать обзор",
    reviewSummary: "Сводка обзоров",
    all: "Все",
    latest: "Новые",
    hot: "Популярные",
    top: "Лучшие",
    write: "Написать",
    writeNew: "Новый пост",
    cancel: "Отмена",
    submit: "Опубликовать",
    submitting: "Публикация...",
    title: "Введите заголовок",
    content: "Введите текст",
    setNickname: "Установить никнейм",
    nickDesc: "Установите никнейм для участия в сообществе",
    nickPlaceholder: "2-20 символов",
    confirm: "Подтвердить",
    backToList: "К списку",
    upvote: "Нравится",
    comments: "Комментарии",
    reply: "Ответить",
    delete: "Удалить",
    edit: "Редактировать",
    editDone: "Сохранить",
    pinned: "Закреплено",
    blinded: "Скрыто модератором",
    noPostsYet: "Пока нет постов",
    beFirst: "Будьте первым!",
    commentPlaceholder: "Написать комментарий",
    loginRequired: "Войдите для комментирования",
    register: "Отправить",
    replyingTo: "Ответ",
    views: "Просмотры",
    blindedComment: "Скрыто модератором",
    tonerPoints: "Тонер-баллы",
    badge: "Значок",
    selectAll: "Заполните все поля",
    globalInquiry: "Международный запрос",
    globalInquiryDesc: "Отправьте запрос о копирах",
    name: "Имя",
    email: "Email",
    country: "Страна",
    subject: "Тема",
    message: "Сообщение",
    send: "Отправить",
    inquirySuccess: "Ваш запрос отправлен. Мы ответим по email.",
    language: "Язык",
    selectCategory: "Выберите категорию",
    postLang: "Язык поста",
    serviceCta: "Заявка на обслуживание",
    serviceCtaDesc: "Визит профессионального инженера",
    rentalCta: "Запрос аренды",
    rentalCtaDesc: "Лучшие условия аренды",
    deleteConfirm: "Удалить?",
    deleted: "Удалено",
  },
  de: {
    community: "Bewertungs-Lounge",
    communityDesc: "Teilen Sie Bewertungen und Geschichten über Kopierer & Drucker",
    review: "Bewertung",
    writeAsReview: "Als Bewertung schreiben",
    reviewSummary: "Bewertungsübersicht",
    all: "Alle",
    latest: "Neueste",
    hot: "Beliebt",
    top: "Top",
    write: "Schreiben",
    writeNew: "Neuer Beitrag",
    cancel: "Abbrechen",
    submit: "Veröffentlichen",
    submitting: "Wird veröffentlicht...",
    title: "Titel eingeben",
    content: "Inhalt eingeben",
    setNickname: "Nickname festlegen",
    nickDesc: "Legen Sie einen Nickname für die Community fest",
    nickPlaceholder: "2-20 Zeichen",
    confirm: "Bestätigen",
    backToList: "Zurück zur Liste",
    upvote: "Empfehlen",
    comments: "Kommentare",
    reply: "Antworten",
    delete: "Löschen",
    edit: "Bearbeiten",
    editDone: "Speichern",
    pinned: "Angepinnt",
    blinded: "Von Moderator ausgeblendet",
    noPostsYet: "Noch keine Beiträge",
    beFirst: "Schreiben Sie den ersten Beitrag!",
    commentPlaceholder: "Kommentar schreiben",
    loginRequired: "Anmelden zum Kommentieren",
    register: "Senden",
    replyingTo: "Antwort",
    views: "Aufrufe",
    blindedComment: "Von Moderator ausgeblendet",
    tonerPoints: "Toner-Punkte",
    badge: "Abzeichen",
    selectAll: "Bitte alle Felder ausfüllen",
    globalInquiry: "Internationale Anfrage",
    globalInquiryDesc: "Senden Sie uns eine Anfrage zu Kopierern",
    name: "Name",
    email: "E-Mail",
    country: "Land",
    subject: "Betreff",
    message: "Nachricht",
    send: "Senden",
    inquirySuccess: "Ihre Anfrage wurde gesendet. Wir antworten per E-Mail.",
    language: "Sprache",
    selectCategory: "Kategorie wählen",
    postLang: "Beitragssprache",
    serviceCta: "Service anfragen",
    serviceCtaDesc: "Professioneller Ingenieurbesuch",
    rentalCta: "Mietanfrage",
    rentalCtaDesc: "Beste Mietberatung",
    deleteConfirm: "Löschen?",
    deleted: "Gelöscht",
  },
};

export const LANGS = [
  { code: "ko", label: "한국어" },
  { code: "en", label: "English" },
  { code: "ja", label: "日本語" },
  { code: "ru", label: "Русский" },
  { code: "de", label: "Deutsch" },
];

export function getT(lang) {
  return T[lang] || T.ko;
}

export default T;
